// SingleJoinTripCard.js

import { useState, useEffect } from "react";
import JoinTripCard from "./JoinTripCard";
import IndividualTripModal from "./IndividualTripModal";
// import { Dialog } from "@mui/material";
import ProfilePage from "../Pages/Profile";
import dayjs from "dayjs";
import { Icons } from "../data/Icons";
import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ProfileDialog from "./ProfileDialog";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { calculateAge } from "../Pages/Profile";


const SingleJoinTripCard = ({ profile, onClick, currentUserId }) => {
    const [isTripOpen, setIsTripOpen] = useState(false);
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [users, setUsers] = useState([]);

    const participants = profile?.participants || [];
    const participantsKey = JSON.stringify(participants);

    useEffect(() => {
        const fetchUsers = async () => {
            if (!participants || participants.length === 0) {
                setUsers([]);
                return;
            }
            try {
                const userPromises = participants.map(id => getDoc(doc(db, 'users', id)));
                const userDocs = await Promise.all(userPromises);
                const newUsers = userDocs.map(doc => doc.exists() ? doc.data() : null).filter(Boolean);
                setUsers(newUsers);
            } catch (error) {
                console.error("Error fetching users:", error);
                setUsers([]);
            }
        };

        fetchUsers();
    }, [participantsKey]);

    if (!profile || !profile.userInfo) {
        return null;
    }

    const formData = profile;

    const handleOpenTrip = () => {
        if(!onClick()){
            setIsTripOpen(true);
        }
    }
    const handleCloseTrip = () => setIsTripOpen(false);
    const handleOpenProfile = () => setIsProfileOpen(true);
    const handleCloseProfile = () => setIsProfileOpen(false);

    const formattedDates = formData.dates?.map((d) => {
        const dateObj = typeof d?.toDate === "function" ? d.toDate() : new Date(d);
        if (isNaN(dateObj.getTime())) return "תאריך לא תקין";
        return dayjs(dateObj).format("DD/MM/YYYY");
    }).join(", ");

    const formattedStyle = (formData.style?.length ? formData.style : [formData.style])
        ?.map((s) => s?.label ?? s)
        .join(", ");

    const formattedRegion = (formData.region?.length ? formData.region : [formData.region])
        ?.map((r) => r?.label ?? r)
        .join(", ");

    const getParticipantsDescription = () => {
        if (users.length === 0) {
            return `${profile.userInfo.name}, ${profile.userInfo.age}`;
        }
        
        let desc = "";
        const length = users.length;
        for (let i = 0; i < length; i++) {
            const age = users[i].birthDate ? calculateAge(dayjs(users[i].birthDate)) : '';
            desc += `${users[i].title} ${age}`;
            if (i !== length - 1) {
                desc += ", ";
            }
        }
        return desc;
    };

    const getTravelPitch = () => {
        if (users.length > 0 && users[0].travelPitch) {
            return `כדאי לטייל איתי כי ${users[0].travelPitch}`;
        }
        return "";
    };



    const descriptionJSX = (
        <>
            {/* The description is now part of the title logic */}
            {formattedDates && (
                <div className="card-description-detail">
                    {Icons.date}{formattedDates}
                </div>
            )}
            {formattedStyle && (
                <div className="card-description-detail">
                    {Icons.style}{formattedStyle}
                </div>
            )}
            {formattedRegion && (
                <div className="card-description-detail">
                    {Icons.location}{formattedRegion}
                </div>
            )}
        </>
    );

    return (
        <>
            <JoinTripCard
                className="trip-card"
                onClick={handleOpenTrip}
                title={getParticipantsDescription()}
                subtitle={<div style={{ fontSize: '16px', fontStyle: 'italic' }}>{getTravelPitch() && `"${getTravelPitch()}"`}</div>}
                participants={participants}
                image={profile.userInfo.coverImage}
                description={descriptionJSX}
            />



            <IndividualTripModal
                isOpen={isTripOpen}
                onClose={handleCloseTrip}
                profile={{
                    ...profile.userInfo,
                    id: profile.id,
                    createdBy: profile.createdBy
                }}
                formData={formData}
                currentUserId={currentUserId}
                onOpenProfile={handleOpenProfile}
            />

            <ProfileDialog
                profileId={profile.createdBy}
                open={isProfileOpen}
                onClose={handleCloseProfile}
            />
        </>
    );
};

export default SingleJoinTripCard;
